export default "__VITE_ASSET__LZq4HKF9__"